import React from 'react';
import { Moon, Sun, Settings as SettingsIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Settings: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen bg-theme-secondary pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <div className="flex items-center mb-8">
            <SettingsIcon className="h-8 w-8 text-theme-secondary mr-3" />
            <h1 className="text-3xl font-bold text-theme-primary">
              Settings
            </h1>
          </div>

          <div className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary">
            <div className="px-6 py-4 border-b border-theme-primary">
              <h2 className="text-lg font-semibold text-theme-primary">
                Appearance
              </h2>
            </div>
            
            <div className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-theme-primary">
                    Theme
                  </h3>
                  <p className="text-sm text-theme-secondary">
                    Choose your preferred theme
                  </p>
                </div>
                
                <button
                  onClick={toggleTheme}
                  className="flex items-center px-4 py-2 bg-theme-secondary rounded-lg hover:bg-theme-tertiary transition-colors"
                >
                  {theme === 'dark' ? (
                    <>
                      <Sun className="h-5 w-5 text-yellow-500 mr-2" />
                      <span className="text-sm font-medium text-theme-primary">
                        Light Mode
                      </span>
                    </>
                  ) : (
                    <>
                      <Moon className="h-5 w-5 text-theme-secondary mr-2" />
                      <span className="text-sm font-medium text-theme-primary">
                        Dark Mode
                      </span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-theme-primary rounded-lg shadow-sm border border-theme-primary">
            <div className="px-6 py-4 border-b border-theme-primary">
              <h2 className="text-lg font-semibold text-theme-primary">
                Account
              </h2>
            </div>
            
            <div className="p-6">
              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-medium text-theme-primary">
                    Email
                  </h3>
                  <p className="text-sm text-theme-secondary">
                    user@example.com
                  </p>
                </div>
                
                <div>
                  <h3 className="text-sm font-medium text-theme-primary">
                    Account Type
                  </h3>
                  <p className="text-sm text-theme-secondary">
                    Personal
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-theme-primary rounded-lg shadow-sm border border-theme-primary">
            <div className="px-6 py-4 border-b border-theme-primary">
              <h2 className="text-lg font-semibold text-theme-primary">
                About
              </h2>
            </div>
            
            <div className="p-6">
              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-medium text-theme-primary">
                    Version
                  </h3>
                  <p className="text-sm text-theme-secondary">
                    1.0.0
                  </p>
                </div>
                
                <div>
                  <h3 className="text-sm font-medium text-theme-primary">
                    Description
                  </h3>
                  <p className="text-sm text-theme-secondary">
                    Saleneum App - Personal all-in-one application for managing car, finance, todo, and health data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 